<div [formGroup]="formGroup" class="flex flex-col gap-2">
  <div class="flex flex-col lg:flex-row gap-2">
    <div class="flex flex-row gap-2 grow">
      <mat-form-field class="grow" floatLabel="always">
        <mat-label>Description</mat-label>
        <input matInput formControlName="description">
      </mat-form-field>
      <mat-form-field class="w-24" floatLabel="always">
        <mat-label>Weight</mat-label>
        <input matInput formControlName="weight" type="number" min="0">
        <span matTextSuffix class="input-suffix">{{ Weight.suffix(weightUnit) }}</span>
      </mat-form-field>
      <mat-form-field class="w-32" floatLabel="always">
        <mat-label>Insurance</mat-label>
        <input matInput formControlName="value" type="number">
        <span matTextSuffix class="input-suffix">{{ currency }}</span>
      </mat-form-field>
    </div>
    <div class="flex flex-row gap-2 grow">
      <mat-form-field class="w-24 grow" floatLabel="always">
        <mat-label>Length</mat-label>
        <input matInput formControlName="length" type="number" min="0">
        <span matTextSuffix class="input-suffix">{{ Dimensions.suffix(dimensionUnit) }}</span>
      </mat-form-field>
      <mat-form-field class="w-24 grow" floatLabel="always">
        <mat-label>Width</mat-label>
        <input matInput formControlName="width" type="number" min="0">
        <span matTextSuffix class="input-suffix">{{ Dimensions.suffix(dimensionUnit) }}</span>
      </mat-form-field>
      <mat-form-field class="w-24 grow" floatLabel="always">
        <mat-label>Height</mat-label>
        <input matInput formControlName="height" type="number" min="0">
        <span matTextSuffix class="input-suffix">{{ Dimensions.suffix(dimensionUnit) }}</span>
      </mat-form-field>
    </div>
  </div>
  @for (group of formCommodities.controls; track group; let i = $index) {
    <div class="flex flex-col">
      <mat-divider></mat-divider>
      <div class="mb-1">Commodity #{{ i + 1 }}</div>
      <app-commodity-form [formGroup]="commodityGroup(i)" [currency]="currency" [weightUnit]="weightUnit"></app-commodity-form>
    </div>
  }
</div>